function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Tandem guarantee"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1313"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1308"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 1049",
  fill: "none",
  d: "M0 0h101v101H0z"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 1307"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1964",
  d: "M48 12h1.5a40.5 40.5 0 010 81h-1A40.5 40.5 0 018 52.5C8 30.132 25.632 12 48 12z",
  fill: "#e8f6f4"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3066",
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2032",
  d: "M50.177 42.165a10.5 10.5 0 1010.5 10.5 10.515 10.515 0 00-10.5-10.5zm5.506 8.4l-5.693 6.159a1.467 1.467 0 01-2.146 0l-3.173-3.453a1.454 1.454 0 012.147-1.96l2.147 2.333 4.62-4.993a1.421 1.421 0 112.1 1.914z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2033",
  d: "M71.83 53.784a1.408 1.408 0 000-2.193l-3.453-2.94a1.448 1.448 0 01-.42-1.587l1.54-4.247a1.476 1.476 0 00-1.12-1.913l-4.48-.84a1.386 1.386 0 01-1.167-1.167l-.793-4.433a1.459 1.459 0 00-1.913-1.12l-4.247 1.54a1.45 1.45 0 01-1.587-.42l-2.94-3.453a1.408 1.408 0 00-2.193 0l-2.893 3.453a1.448 1.448 0 01-1.587.42l-4.247-1.54a1.443 1.443 0 00-1.913 1.12l-.84 4.48a1.386 1.386 0 01-1.167 1.167l-4.433.793a1.459 1.459 0 00-1.12 1.913l1.54 4.247a1.449 1.449 0 01-.42 1.587l-3.453 2.94a1.408 1.408 0 000 2.193l3.453 2.94a1.448 1.448 0 01.42 1.586l-1.54 4.247a1.416 1.416 0 001.12 1.866l4.48.793a1.386 1.386 0 011.167 1.167l.793 4.48a1.459 1.459 0 001.913 1.12l4.246-1.54a1.45 1.45 0 011.587.42l2.94 3.453a1.408 1.408 0 002.193 0l2.94-3.453a1.448 1.448 0 011.586-.42l4.247 1.54a1.476 1.476 0 001.913-1.12l.793-4.48a1.386 1.386 0 011.167-1.167l4.48-.793a1.459 1.459 0 001.12-1.913l-1.588-4.247a1.45 1.45 0 01.42-1.587zM50.178 66.01a13.346 13.346 0 1113.346-13.346A13.343 13.343 0 0150.178 66.01z"
})));
var SvgTandemGuarantee = function SvgTandemGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101
  }, props), _ref);
};
export default SvgTandemGuarantee;